import styled from "styled-components";
import {hexToRgba} from "../../../../../../themes/hex-to-rgba";
import {LiveCasinoGridItemInfobarDefaultBox} from "./live-casino-grid-item-infobar.default.box";

export const LiveCasinoGridItemInfobarMrGreenBox = styled(LiveCasinoGridItemInfobarDefaultBox)`
   background: ${props => hexToRgba(props.theme.colors.horizontalLineBackgroundColor, 0.6)};
   &::before {
      background: none;
   }
`;
